export interface UploadProgress { loaded: number; total: number; }

// POST einer FormData via XMLHttpRequest, um echten Upload-BYTE-Fortschritt zu
// bekommen (fetch() liefert keinen Upload-Progress). Gibt die geparste JSON-Antwort
// zurück; Fehler-Status → Error mit .status, Netzwerk-/Cross-Origin-Fehler (z.B. eine
// abgelaufene ZT-Session, die auf CF Access umleitet) → Error('unauthorized').
// Same-Origin (/api via Pages-Proxy) → Cookies/Proxy-Auth laufen wie bei fetch.
export function xhrUpload<T>(
  url: string,
  body: XMLHttpRequestBodyInit,
  onProgress?: (p: UploadProgress) => void,
  contentType?: string,
): Promise<T> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.responseType = 'text';
    // Nur für rohen Body (Blob/File) setzen — bei FormData NICHT (Browser setzt den
    // multipart-boundary selbst). Content-Length setzt der Browser aus der Blob-Größe.
    if (contentType) xhr.setRequestHeader('Content-Type', contentType);
    if (onProgress) {
      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) onProgress({ loaded: e.loaded, total: e.total });
      };
    }
    xhr.onload = () => {
      const status = xhr.status;
      if (status >= 200 && status < 300) {
        try { resolve(JSON.parse(xhr.responseText) as T); }
        catch { reject(new Error('invalid_response')); }
        return;
      }
      let message = xhr.responseText;
      try {
        const parsed = JSON.parse(xhr.responseText);
        if (parsed?.error) message = String(parsed.error);
      } catch { /* Rohtext behalten */ }
      const err = new Error(`${status} ${message}`) as Error & { status?: number };
      err.status = status;
      reject(err);
    };
    xhr.onerror = () => reject(new Error('unauthorized'));
    xhr.onabort = () => reject(new Error('aborted'));
    xhr.send(body);
  });
}
